import React from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { Flex, Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';

/**
 * This component shows indication that the user has no permissions to see the referenced entity.
 */
const ReferenceActivityCardNoPermission = React.forwardRef((props, ref) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <ActivityCard ref={ref} {...props}>
      <Flex alignItems="center">
        <Text typography="bodySmall" color="charcoal700">
          {T.translate('ACTIVITY_NO_PERMISSIONS')}
        </Text>
      </Flex>
    </ActivityCard>
  );
});

ReferenceActivityCardNoPermission.displayName =
  'ReferenceActivityCardNoPermission';

ReferenceActivityCardNoPermission.propTypes = {
  ...ActivityCard.propTypes,
};

export default ReferenceActivityCardNoPermission;
